export const events = {
  goToTeams: 'Go to teams',
  createNewTeamStart: 'Create new team start',
  goToTeamsDetails: 'Go to teams details',
  createNewTeamCancel: 'Create new team cancel',
  createNewTeamSubmit: 'Create new team submit',
  addTeamDetailsMembersStart: 'Add team details members start',
  addTeamDetailsMembersCancel: 'Add team details members cancel',
  addTeamDetailsMembersSubmit: 'Add team details members submit',
  addTeamDetailsLeaderStart: 'Add team details leader start',
  addTeamDetailsLeaderCancel: 'Add team details leader cancel',
  addTeamDetailsLeaderSubmit: 'Add team details leader submit',
  renameTeamCancel: 'Rename team cancel',
  renameTeamSubmit: 'Rename team submit',
  deleteTeamStart: 'Delete team start',
  deleteTeamCancel: 'Delete team cancel',
  deleteTeamSubmit: 'Delete team submit',
  createAddDescriptionInTeam: 'Create add description in team',
  configureTeamPage: 'Configure team page',
  goToEditTeamInformation: 'Go to edit team information',
  goToDeleteTeamInformation: 'Go to delete team information',
  createNewTeamName: 'Create new team name',
  createNewTeamDescription: 'Create new team description',
  editTeamName: 'Edit team name',
  editTeamDescription: 'Edit team description',
  saveEditTeamInformationSubmit: 'Save edit team information submit',
  goToUploadPhoto: 'Go to upload photo',
  assignJobThroughTeamList: 'Assign job through team list',
  createJobThroughTeamList: 'Create job through team list',
}
